<template>
    <div>
        <!-- 页面固定头部 -->
        <a-anchor :getContainer="getModuleContainer" style="width:100%">
            <!-- 面包屑组件 -->
            <FGBreadHead></FGBreadHead>
            <!-- //文本搜索内容 -->
            <div class="fun-panel fun-search-form-wrapper">
                <a-form :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }">
                    <a-row :gutter="[0, 6]">
                        <a-col :span="6">
                            <a-form-item label="年份">
                                <FGDictSelectCN dictNo="P0002" v-model="queryParams.nf" placeholder="" mode="multiple" />
                            </a-form-item>
                        </a-col>
                        <a-col :span="6">
                            <a-form-item label="期数">
                                <a-input v-model="queryParams.qs" type="number" />
                            </a-form-item>
                        </a-col>
                        <a-col :span="6">
                            <a-form-item label="状态">
                                <FGDictSelectCN dictNo="HK100101" v-model="queryParams.djzt" mode="multiple" />
                            </a-form-item>
                        </a-col>
                        <a-col :span="6">
                            <a-form-item label="接收单位范围">
                                <FGDictSelectCN dictNo="DW100102" v-model="queryParams.jsdwfw" mode="multiple" />
                            </a-form-item>
                        </a-col>
                    </a-row>
                    <a-row :gutter="[0, 6]">
                        <a-col :span="6">
                            <a-form-item label="下载次数从">
                                <a-input v-model="queryParams.xzcs1" type="number" />
                            </a-form-item>
                        </a-col>
                        <a-col :span="6">
                            <a-form-item label="到">
                                <a-input v-model="queryParams.xzcs2" type="number" />
                            </a-form-item>
                        </a-col>
                        <a-col :span="12">
                            <span class="fun-search-form-buttons" :style="{ float: 'right', overflow: 'hidden' }">
                                <a-button type="primary" @click="loadData" style="margin-right: 8px">查询</a-button>
                                <a-button @click="reset">重置</a-button>
                            </span>
                        </a-col>
                    </a-row>
                </a-form>
            </div>
        </a-anchor>
        <div class="fun-panel">
            <a-spin :spinning="tableDataLoading">
                <vxe-toolbar
                    size="mini"
                    custom
                    :refresh="{
                        query: () => {
                            this.loadData();
                        }
                    }"
                >
                </vxe-toolbar>

                <vxe-table
                    ref="table"
                    size="mini"
                    resizable
                    row-id="id"
                    auto-resize
                    align="left"
                    :max-height="$FG_util.getTableHeightDirect(2)"
                    show-overflow="tooltip"
                    header-align="center"
                    :data="tableData"
                    highlight-hover-row
                    highlight-current-row
                    :sort-config="{
                        trigger: 'cell',
                        defaultSort: { field: sort.field, order: sort.order },
                        remote: true,
                        orders: ['asc', 'desc']
                    }"
                    @sort-change="handleSortChange"
                    @cell-dblclick="doubleClick"
                >
                    <vxe-table-column type="seq" title="序号" width="70" align="center"></vxe-table-column>
                    <vxe-table-column field="djzt" title="状态" width="80" align="center"></vxe-table-column>
                    <vxe-table-column field="hkbh" title="会刊编号" width="120" align="center" sortable></vxe-table-column>
                    <vxe-table-column field="nf" title="年份" width="100" align="center"></vxe-table-column>
                    <vxe-table-column field="qs" title="期数" width="100" align="center"></vxe-table-column>
                    <vxe-table-column field="zqs" title="总期数" width="100" align="center"></vxe-table-column>
                    <vxe-table-column field="hkmc" title="会刊名称" width="200"></vxe-table-column>
                    <vxe-table-column field="cbrq" title="出版日期" width="120" sortable align="center"> </vxe-table-column>
                    <vxe-table-column field="fssj" title="发送日期" width="150" sortable align="center"> </vxe-table-column>
                    <vxe-table-column field="jsdwfw" title="接收单位范围" width="260"> </vxe-table-column>
                    <vxe-table-column field="xzcs" title="下载次数" width="100" sortable align="center"> </vxe-table-column>
                    <vxe-table-column field="bz" title="备注" min-width="100"> </vxe-table-column>
                    <vxe-table-column title="操作" align="center" width="100">
                        <template v-slot="scope">
                            <span class="btn_edit" @click="view(scope.row)">查看</span>
                        </template>
                    </vxe-table-column>
                </vxe-table>
                <vxe-pager
                    background
                    size="mini"
                    :current-page.sync="pageinfo.pageNo"
                    :page-size.sync="pageinfo.pageSize"
                    :total="pageinfo.total"
                    :layouts="['PrevJump', 'PrevPage', 'Number', 'NextPage', 'NextJump', 'Sizes', 'FullJump', 'Total']"
                    @page-change="handlePageChange"
                >
                </vxe-pager>
            </a-spin>
        </div>
    </div>
</template>

<script>
export default {
    name: "HkxxcxBrowse",
    components: {},
    data() {
        return {
            tableData: [], //表格数据
            queryParams: { funid: "HK1002" },
            // 分页
            pageinfo: {
                pageNo: 1,
                pageSize: 20,
                total: 0
            },
            // 排序
            sort: {
                field: "hkbh",
                order: "desc"
            },
            tableDataLoading: false,
            btnPrimary: "primary",
            btnDefault: "default",
            selDJZT: 0,
            isShow: false
        };
    },
    computed: {
        // 是否显示编辑界面
        editIsVisible: {
            get() {
                return this.showEdit;
            },
            set(newVal) {
                this.$emit("update:showEdit", newVal);
            }
        },
        formIsVisible: {
            get() {
                return this.showForm;
            },
            set(newVal) {
                this.$emit("update:showForm", newVal);
            }
        },
        // 当前编辑记录id
        editDataId: {
            get() {
                return this.dataId;
            },
            set(newVal) {
                this.$emit("update:dataId", newVal);
            }
        }
    },
    activated() {
        this.loadData(this.editDataId);
    },
    methods: {
        //双击事件
        doubleClick({ row }) {
            this.view(row);
        },
        //点击页码
        handlePageChange({ currentPage, pageSize }) {
            this.pageinfo.pageNo = currentPage;
            this.pageinfo.pageSize = pageSize;
            this.loadData();
        },
        //点击表头排序
        handleSortChange({ property, order }) {
            this.sort.field = property;
            this.sort.order = order;
            this.loadData();
        },
        //查看
        view(row) {
            // 设置编辑记录id
            this.editDataId = row.id;
            // 显示编辑界面
            this.editIsVisible = false;
            this.formIsVisible = true;
        },
        //查询列表数据
        loadData(id) {
            this.tableDataLoading = true;
            this.$FG_http
                .post(
                    "./api/main/zxdw/hkgl/list",
                    {
                        funid: "HK1002",
                        menuid: "AC78AC40-738E-4605-8C13-C3F4094E9ACC",
                        defaulttablename: "DW_HKJL",
                        pageNo: this.pageinfo.pageNo,
                        pageSize: this.pageinfo.pageSize,
                        queryParams: this.queryParams,
                        sort: this.sort
                    },
                    {
                        showSuccess: false
                    }
                )
                .then(({ success, data, errMsg }) => {
                    this.tableDataLoading = false;
                    if (success) {
                        this.tableData = data.data;
                        // 需要设置当前页，因为查询可能导致当前页发生变化
                        this.pageinfo.pageNo = data.pageinfo.pagenum;
                        this.pageinfo.total = data.pageinfo.maxrow;
                    } else {
                        // 数据加载失败清空表格
                        this.tableData = [];
                    }
                });
        },
        //重置文本内容
        reset() {
            this.queryParams = {};
        }
    }
};
</script>
